import { FAQs } from '../FAQs'
import { useEliteLandingPageScrollEvent } from '../../../hooks/useEliteLandingPageScrollEvent'
import { RightChevronBoxGroup } from '../../ui-components/RightChevronBoxGroup'

import { getEliteBuyCtaEventExtras } from '../../../utils/eliteEventExtras'
import BottomSheetContent from '../../BottomSheetComponents/BottomSheetContent'
import { useBottomSheet } from '../../../state-management/contexts/BottomSheetContext'
import Button from '../../ui-components/Button'
import RenderHTML from '../../ui-components/RenderHTML'
import { postCTA, trackEvent } from '../../../utils/appBridge'
import { SUPPORT_CTA } from '../../../utils/commonAppCTAs'
import { EventNames, type EliteOnboardingStatusResponse } from '../../../types/misc.types'
import { getBottomPadding } from '../../../utils/sessionStorage'
import {
  EliteReferralInviteBanner,
  shouldShowEliteReferralInviteBanner
} from '../EliteReferralInviteBanner'

export const EliteDashboardBody = ({
  cancelMembershipCTA,
  eliteOnboardingStatus
}: {
  cancelMembershipCTA: Record<any, any> | undefined
  eliteOnboardingStatus?: EliteOnboardingStatusResponse
}) => {
  const { openBottomSheet, closeBottomSheet } = useBottomSheet()

  const screenType = 'MF_Elite_Dashboard'

  const faqRef = useEliteLandingPageScrollEvent({ sectionName: 'FAQ' })

  const handleCancelBottomSheetClose = () => {
    trackEvent({
      eventName: EventNames.ButtonTap,
      payload: {
        ...getEliteBuyCtaEventExtras(eliteOnboardingStatus),
        buttonLabel: 'Go Back',
        ScreenName: 'MF_Elite_Dashboard'
      }
    })
    closeBottomSheet()
  }

  return (
    <div
      style={{ paddingBottom: `calc(${getBottomPadding()}px + 160px)` }}
      className='flex flex-col bg-[#EBF2F2] gap-5 rounded-xl overflow-hidden'
    >
      {shouldShowEliteReferralInviteBanner(eliteOnboardingStatus) ? (
        <div className='px-5 pt-5'>
          <EliteReferralInviteBanner screenName={screenType} />
        </div>
      ) : null}
      <div ref={faqRef}>
        <FAQs />
      </div>

      <div className='px-5'>
        <RightChevronBoxGroup
          boxes={[
            {
              label: 'Terms and Conditions',
              action: () => {
                trackEvent({
                  eventName: EventNames.UserClicked,
                  payload: {
        ...getEliteBuyCtaEventExtras(eliteOnboardingStatus),
                    eventId: 'T&C',
                    screenType
                  }
                })
                postCTA(JSON.stringify(termsAndConditionsCTA))
              }
            },
            {
              label: 'Get Support',
              action: () => {
                trackEvent({
                  eventName: EventNames.UserClicked,
                  payload: {
        ...getEliteBuyCtaEventExtras(eliteOnboardingStatus),
                    eventId: 'Get Support',
                    screenType
                  }
                })
                postCTA(JSON.stringify(SUPPORT_CTA))
              }
            },
            {
              label: 'Disclaimer',
              action: () => {
                trackEvent({
                  eventName: EventNames.UserClicked,
                  payload: {
        ...getEliteBuyCtaEventExtras(eliteOnboardingStatus),
                    eventId: 'Disclaimer',
                    screenType
                  }
                })
                openBottomSheet(
                  <BottomSheetContent heading='Disclaimer' onDismiss={closeBottomSheet}>
                    <DisclaimerBottomSheetContent />
                  </BottomSheetContent>
                )
              }
            }
          ]}
        />
      </div>

      {false && (
        <div className='px-5'>
          <RightChevronBoxGroup
            boxes={[
              {
                label: 'Cancel Membership',
                action: () => {
                  trackEvent({
                    eventName: EventNames.UserClicked,
                    payload: {
        ...getEliteBuyCtaEventExtras(eliteOnboardingStatus),
                      eventId: 'Cancel Membership',
                      screenType
                    }
                  })
                  openBottomSheet(
                    <BottomSheetContent
                      heading='Thinking of cancelling?'
                      onDismiss={handleCancelBottomSheetClose}
                      bottomSheetCtas={
                        <CancelMembershipCTAs
                          onCancellation={() => {
                            trackEvent({
                              eventName: EventNames.ButtonTap,
                              payload: {
        ...getEliteBuyCtaEventExtras(eliteOnboardingStatus),
                                buttonLabel: 'Continue with Cancellation',
                                ScreenName: 'MF_Elite_Dashboard'
                              }
                            })
                            postCTA(JSON.stringify(cancelMembershipCTA))
                          }}
                          onDismiss={handleCancelBottomSheetClose}
                        />
                      }
                    >
                      <CancelMembershipBottomSheetContent />
                    </BottomSheetContent>
                  )
                }
              }
            ]}
          />
        </div>
      )}
    </div>
  )
}

export const DisclaimerBottomSheetContent = () => {
  return (
    <div className='text-[14px] text-[#6A6E6E]  '>
      Uniorbit Wealth Management Private Limited is a SEBI Registered Investment Adviser vide Registration No:
      INA000019798.
      <br />
      <br />
      Investments in securities market is subject to market risk. Read all documents carefully before investing.
      <br />
      <br />
      Past performance is not indicative of future results, and no representation or warranty, express or implied, is
      made regarding the accuracy, completeness, or reliability of the information provided. Investors are advisedto
      conduct their own due diligence before making any investment decisions.
      <br />
      <br />
      Uniorbit Wealth Management Private Limited does not guarantee any returns or profits from the recommendations
      provided. The investment decisions taken by clients based on the information provided are solely their own
      responsibility, and Uniorbit Wealth Management Private Limited shall not be held liable for any losses incurred.
    </div>
  )
}

export const CancelMembershipBottomSheetContent = () => {
  return (
    <div className='text-[13px] text-[#6A6E6E]'>
      Just a reminder. It means you’ll lose access to:
      <div className='flex flex-col gap-6 pt-6 pb-7'>
        <div className='flex gap-3'>
          <div>
            <RenderHTML innerHTMLText={powerRankIcon} />
          </div>
          <div className='flex flex-col text-[13px] flex-1'>
            <div className='text-[#232323] font-[500]'>Power Rank</div>
            <div className='text-[#8E9393] font-[400] max-w-[85%]'>Unlocks exact rank of any mutual fund</div>
          </div>
        </div>
        <div className='flex gap-3'>
          <div>
            <RenderHTML innerHTMLText={fundScoresIcon} />
          </div>
          <div className='flex flex-col text-[13px] flex-1'>
            <div className='text-[#232323] font-[500]'>Fund Scores</div>
            <div className='text-[#8E9393] font-[400] max-w-[85%]'>Reveals why certain funds do better</div>
          </div>
        </div>
        <div className='flex gap-3'>
          <div>
            <RenderHTML innerHTMLText={otherRankTrendsIcon} />
          </div>
          <div className='flex flex-col text-[13px] flex-1'>
            <div className='text-[#232323] font-[500]'>Other Rank Trends</div>
            <div className='text-[#8E9393] font-[400] max-w-[85%]'>Shows consistency of a fund</div>
          </div>
        </div>
      </div>
      <hr className='border border-[#EBF2F2]' />
      <div className='pb-2 pt-6'>
        You’re covered by our 15-day money-back guarantee. Refund will be processed in 5-7 working days.
      </div>
    </div>
  )
}

export const CancelMembershipCTAs = ({
  onCancellation,
  onDismiss
}: {
  onCancellation: () => void
  onDismiss: () => void
}) => {
  return (
    <div className='flex flex-col gap-4 w-full'>
      <div>
        <Button
          buttonClassName='!min-h-[58px] w-full !bg-[#232323] rounded-xl text-white text-[16px]'
          isFullWidth
          onClick={onCancellation}
        >
          Continue with cancellation
        </Button>
      </div>
      <div className='border border-[#D1D6D6] rounded-xl'>
        <Button
          buttonClassName='!min-h-[52px] w-full rounded-xl text-[#232323] text-[16px] bg-white'
          isFullWidth
          onClick={onDismiss}
        >
          Go back
        </Button>
      </div>
    </div>
  )
}

const powerRankIcon = `<svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1 13.5a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H9a8 8 0 0 1-8-8v-16Z" fill="#EBF2F2"/>
  <path d="M13.303 30c.144.074.194.236.113.365-.081.128-.264.173-.409.1a10.776 10.776 0 0 1-2.283-1.55 5.142 5.142 0 0 1-1.171.497c-.46.126-.92.17-1.332.104a2.92 2.92 0 0 1-1.24-.517 3.095 3.095 0 0 1-.892-1.022.247.247 0 0 1 .074-.318 3.46 3.46 0 0 1 1.227-.663 3.047 3.047 0 0 1 1.638-.031 8.563 8.563 0 0 1-.28-.454 9.008 9.008 0 0 1-.65-1.365 4.452 4.452 0 0 1-1.026.076 3.01 3.01 0 0 1-1.138-.262 2.486 2.486 0 0 1-.954-.78 2.647 2.647 0 0 1-.476-1.14c-.021-.119.05-.23.164-.279a3.478 3.478 0 0 1 1.316-.268c.476-.006.93.081 1.272.241.125.059.23.115.32.172a8.483 8.483 0 0 1 .191-2.746 3.894 3.894 0 0 1-.78-.26 2.442 2.442 0 0 1-.804-.571 1.996 1.996 0 0 1-.48-.966 2.31 2.31 0 0 1 .07-1.11c.035-.116.15-.194.279-.198a3.25 3.25 0 0 1 1.215.207c.402.15.75.372.972.617.104.117.183.22.242.316a9.207 9.207 0 0 1 1.333-1.97 3.369 3.369 0 0 1 .14-1.514 3.01 3.01 0 0 1 .885-1.313 3.57 3.57 0 0 1 1.51-.769 4.827 4.827 0 0 1 1.853-.073c.132.02.23.115.248.227a3.4 3.4 0 0 1-.116 1.643c-.168.499-.463.953-.89 1.325-.428.376-.944.63-1.509.77a4.79 4.79 0 0 1-1.699.093 9.04 9.04 0 0 0-.727.969l-.087.137a3.263 3.263 0 0 1 1.023-.206c.287-.012.582.011.865.081.13.031.218.134.224.248.018.388-.052.762-.209 1.097a2.13 2.13 0 0 1-.71.844c-.19.136-.417.243-.667.321a3.68 3.68 0 0 1-.82.153 4.519 4.519 0 0 1-.767-.006 8.145 8.145 0 0 0-.212 2.15c.172-.244.43-.479.742-.675a3.492 3.492 0 0 1 1.152-.455l.093-.015v-.001l.094-.013a.309.309 0 0 1 .319.155c.207.38.322.78.33 1.173h0a2.069 2.069 0 0 1-.547 1.458c-.221.241-.513.457-.844.635-.25.135-.525.25-.811.339a8.583 8.583 0 0 0 .822 1.621c.008-.065.018-.129.03-.194.084-.411.285-.783.576-1.102a3.294 3.294 0 0 1 1.143-.791.326.326 0 0 1 .365.07c.342.325.6.695.748 1.087.148.39.192.8.108 1.212-.068.34-.25.68-.512.994-.206.25-.46.485-.744.695A10.18 10.18 0 0 0 13.303 30V30Zm-2.728-1.642.017-.01c.344-.223.649-.484.88-.764.207-.25.352-.515.404-.773.065-.32.03-.642-.085-.947-.101-.264-.263-.519-.478-.75-.293.15-.544.338-.741.553-.226.249-.385.54-.449.861-.04.2-.044.398-.012.59.031.203.102.402.204.593.052.1.032.222-.06.304a.327.327 0 0 1-.424-.002l-.015-.01a2.282 2.282 0 0 0-1.17-.567 2.359 2.359 0 0 0-1.065.07 2.81 2.81 0 0 0-.846.42c.17.26.38.484.624.662.282.203.61.344.971.403.312.052.673.015 1.044-.087a4.49 4.49 0 0 0 1.202-.544v-.002Zm-2.36-3.787h.003c.34-.085.668-.209.957-.364.275-.148.512-.322.69-.516a1.513 1.513 0 0 0 .19-.25c.158-.268.228-.561.223-.862a2.013 2.013 0 0 0-.181-.768 2.84 2.84 0 0 0-.861.356c-.283.177-.507.387-.63.595a2.922 2.922 0 0 0-.26.532 1.033 1.033 0 0 0-.045.442l.004.035.008.058c.016.11-.046.222-.164.274-.15.064-.329.011-.403-.12l-.032-.058c-.174-.31-.28-.499-.74-.716-.254-.118-.605-.182-.983-.176a2.967 2.967 0 0 0-.855.134c.069.266.183.512.342.725.185.25.43.457.732.6.258.12.562.184.89.2a3.94 3.94 0 0 0 1.113-.118l.002-.003Zm.615-5.74-.015.024a.968.968 0 0 0-.072.125c-.024.05-.046.105-.065.16-.03.112-.14.198-.277.203-.166.008-.306-.107-.314-.254l-.004-.057c-.017-.309-.028-.498-.317-.821-.158-.177-.42-.341-.733-.457a2.6 2.6 0 0 0-.733-.16 1.78 1.78 0 0 0-.008.681c.05.265.169.51.358.724.154.173.366.317.61.43.274.127.588.215.914.265.149.02.299.034.45.04.148.006.298.004.446-.008.24-.019.468-.06.672-.124.188-.06.358-.138.496-.237.238-.168.414-.383.528-.63.096-.204.15-.43.161-.667a2.702 2.702 0 0 0-1.15.1c-.083.027-.166.06-.242.096-.07.034-.134.07-.188.109h-.002a3.618 3.618 0 0 0-.329.255 1.293 1.293 0 0 0-.188.204h.002Zm4.927-4.558c.127-.379.167-.791.124-1.216a4.102 4.102 0 0 0-1.371.088 2.98 2.98 0 0 0-1.25.633c-.35.306-.593.677-.732 1.09-.13.382-.172.798-.127 1.226.476.045.941.017 1.37-.089.471-.116.9-.326 1.25-.632.353-.309.597-.685.737-1.1h0ZM20.697 30c-.144.074-.194.236-.113.365.081.128.264.173.409.1a10.776 10.776 0 0 0 2.283-1.55c.373.215.773.387 1.171.497.46.126.92.17 1.332.104.462-.077.88-.257 1.24-.517.366-.267.67-.615.892-1.022a.247.247 0 0 0-.074-.318 3.46 3.46 0 0 0-1.227-.663 3.045 3.045 0 0 0-1.638-.031c.098-.15.193-.302.28-.454.256-.44.473-.895.65-1.365.342.064.69.092 1.026.076a3.01 3.01 0 0 0 1.138-.262c.395-.186.715-.454.954-.78.245-.33.405-.72.476-1.14.021-.119-.05-.23-.164-.279a3.478 3.478 0 0 0-1.316-.268c-.476-.006-.93.081-1.272.241-.125.059-.23.115-.32.172a8.476 8.476 0 0 0-.191-2.746c.274-.062.538-.148.78-.26.318-.146.595-.337.804-.571.255-.285.414-.616.48-.966.07-.357.043-.737-.07-1.11-.035-.116-.15-.194-.279-.198a3.25 3.25 0 0 0-1.215.207c-.402.15-.75.372-.972.617a2.23 2.23 0 0 0-.242.316 9.213 9.213 0 0 0-1.333-1.97 3.37 3.37 0 0 0-.14-1.514 3.01 3.01 0 0 0-.885-1.313 3.57 3.57 0 0 0-1.51-.769 4.827 4.827 0 0 0-1.853-.073c-.132.02-.23.115-.248.227a3.4 3.4 0 0 0 .116 1.643c.168.499.463.953.89 1.325.428.376.944.63 1.509.77a4.79 4.79 0 0 0 1.699.093c.262.305.507.628.727.969l.087.137a3.264 3.264 0 0 0-1.023-.206 3.075 3.075 0 0 0-.865.081c-.13.031-.219.134-.224.248-.018.388.052.762.209 1.097.152.328.39.617.71.844.19.136.417.243.667.321.255.08.533.131.82.153a4.52 4.52 0 0 0 .767-.006 8.145 8.145 0 0 1 .212 2.15 2.61 2.61 0 0 0-.742-.675 3.493 3.493 0 0 0-1.152-.455l-.093-.015v-.001l-.094-.013a.309.309 0 0 0-.319.155c-.207.38-.322.78-.33 1.173h0a2.069 2.069 0 0 0 .547 1.458c.221.241.513.457.844.635.25.135.526.25.811.339a8.583 8.583 0 0 1-.822 1.621 3.047 3.047 0 0 0-.03-.194 2.316 2.316 0 0 0-.576-1.102 3.294 3.294 0 0 0-1.143-.791.326.326 0 0 0-.365.07c-.342.325-.6.695-.748 1.087-.148.39-.192.8-.108 1.212.068.34.25.68.512.994.206.25.46.485.744.695A10.18 10.18 0 0 1 20.697 30V30Zm2.728-1.642-.017-.01a3.886 3.886 0 0 1-.88-.764c-.207-.25-.352-.515-.404-.773-.065-.32-.03-.642.085-.947.101-.264.263-.519.478-.75.293.15.544.338.741.553.226.249.385.54.449.861.04.2.044.398.012.59a1.894 1.894 0 0 1-.204.593.247.247 0 0 0 .06.304.327.327 0 0 0 .424-.002l.014-.01a2.282 2.282 0 0 1 1.17-.567c.362-.06.723-.032 1.066.07.299.088.584.231.846.42-.17.26-.38.484-.624.662-.282.203-.61.344-.971.403-.312.052-.673.015-1.044-.087a4.49 4.49 0 0 1-1.202-.544v-.002Zm2.36-3.787h-.003a4.16 4.16 0 0 1-.957-.364 2.622 2.622 0 0 1-.69-.516 1.5 1.5 0 0 1-.19-.25 1.613 1.613 0 0 1-.223-.862c.006-.253.069-.514.181-.768.312.07.607.198.861.356.283.177.507.387.63.595.125.213.21.382.26.532a1.031 1.031 0 0 1 .045.442l-.004.035-.008.058c-.016.11.046.222.164.274.15.064.329.011.403-.12l.032-.058c.174-.31.28-.499.74-.716.254-.118.605-.182.983-.176.286.003.581.046.855.134a2.08 2.08 0 0 1-.342.725 1.92 1.92 0 0 1-.732.6 2.368 2.368 0 0 1-.89.2 3.936 3.936 0 0 1-1.113-.118l-.002-.003Zm-.615-5.74.015.024a.97.97 0 0 1 .072.125c.023.05.046.105.065.16.03.112.14.198.277.203.166.008.306-.107.314-.254l.004-.057c.017-.309.028-.498.317-.821.158-.177.42-.341.733-.457.228-.085.48-.143.733-.16.046.233.05.463.008.681-.05.265-.169.51-.358.724a1.86 1.86 0 0 1-.61.43 3.388 3.388 0 0 1-.914.265 3.95 3.95 0 0 1-.896.032c-.24-.019-.468-.06-.672-.124a1.78 1.78 0 0 1-.496-.237 1.567 1.567 0 0 1-.528-.63 1.758 1.758 0 0 1-.161-.667 2.701 2.701 0 0 1 1.15.1 2 2 0 0 1 .242.096c.07.034.134.07.188.109h.002c.134.095.243.179.329.255.076.068.137.134.188.204h-.002Zm-4.927-4.558a2.894 2.894 0 0 1-.124-1.216 4.102 4.102 0 0 1 1.371.088c.471.116.897.327 1.25.633.35.306.593.677.732 1.09.13.382.172.798.127 1.226a4.102 4.102 0 0 1-1.37-.089c-.471-.116-.9-.326-1.25-.632a2.519 2.519 0 0 1-.737-1.1h0Z" fill="#8E9393" stroke="#8E9393" stroke-width=".2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M32 14a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z" fill="#E77464"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M29.825 3.727a.776.776 0 1 0-1.098 1.098L30.902 7l-2.175 2.175a.776.776 0 1 0 1.098 1.098L32 8.098l2.175 2.175a.776.776 0 0 0 1.097-1.098L33.098 7l2.175-2.175a.776.776 0 1 0-1.098-1.097L32 5.902l-2.175-2.175Z" fill="#fff"/>
</svg>`

const fundScoresIcon = `<svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="1" y="5.25" width="32" height="32" rx="8" fill="#EBF2F2"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M16.42 12.972a1.124 1.124 0 0 1 1.573.447l.003.005.866 1.706h1.38a1.11 1.11 0 0 1 .792 1.905l-1.316 1.296.734 1.685a1.116 1.116 0 0 1-1.586 1.397l-1.868-1.051-1.87 1.051a1.115 1.115 0 0 1-1.585-1.397l.003-.009.73-1.677-1.32-1.3a1.11 1.11 0 0 1 .793-1.905h1.382l.872-1.718c.097-.18.241-.33.417-.435Zm.575 1.243.927 1.823c.106.21.322.342.557.342h1.439l-1.383 1.361a.625.625 0 0 0-.135.695l.739 1.696-1.835-1.032a.625.625 0 0 0-.612 0l-1.837 1.032.739-1.696a.625.625 0 0 0-.135-.695l-1.386-1.366h1.442c.235 0 .45-.132.557-.342l.923-1.818Zm-6.204 6.888a1.125 1.125 0 0 1 1.575.438l.005.009.866 1.705h1.382a1.11 1.11 0 0 1 .792 1.906l-1.319 1.295.733 1.685a1.116 1.116 0 0 1-1.585 1.397l-1.87-1.052-1.87 1.052a1.116 1.116 0 0 1-1.585-1.397l.004-.01.73-1.676-1.317-1.299a1.11 1.11 0 0 1 .792-1.905h1.382l.87-1.71c.097-.181.24-.332.415-.438Zm.58 1.24.925 1.82c.107.21.322.342.558.342h1.44l-1.384 1.36a.625.625 0 0 0-.135.695l.737 1.697-1.835-1.032a.625.625 0 0 0-.613 0l-1.836 1.032.739-1.696a.625.625 0 0 0-.135-.695l-1.384-1.365H9.89c.235 0 .45-.132.557-.341l.925-1.818Zm11.255-1.402a1.125 1.125 0 0 0-.995.6l-.871 1.714h-1.382a1.11 1.11 0 0 0-.792 1.905l1.319 1.3-.729 1.671-.004.01a1.116 1.116 0 0 0 1.586 1.397l1.869-1.052 1.87 1.052a1.115 1.115 0 0 0 1.585-1.397l-.734-1.686 1.32-1.299a1.11 1.11 0 0 0-.793-1.905H24.49l-.866-1.702-.005-.008a1.126 1.126 0 0 0-.994-.6Zm.925 3.219-.925-1.818-.925 1.821a.625.625 0 0 1-.558.342h-1.441l1.386 1.365a.625.625 0 0 1 .134.695l-.737 1.692 1.835-1.032a.625.625 0 0 1 .613 0l1.836 1.032-.738-1.696a.625.625 0 0 1 .134-.695l1.386-1.365h-1.443a.625.625 0 0 1-.557-.341Z" fill="#8E9393"/>
  <path d="M32 14a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z" fill="#E77464"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M29.825 3.727a.776.776 0 1 0-1.098 1.098L30.902 7l-2.175 2.175a.776.776 0 1 0 1.098 1.098L32 8.098l2.175 2.175a.776.776 0 0 0 1.097-1.098L33.098 7l2.175-2.175a.776.776 0 1 0-1.098-1.097L32 5.902l-2.175-2.175Z" fill="#fff"/>
</svg>`

const otherRankTrendsIcon = `<svg width="40" height="40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M1 13.25a8 8 0 0 1 8-8h16a8 8 0 0 1 8 8v16a8 8 0 0 1-8 8H9a8 8 0 0 1-8-8v-16Z" fill="#EBF2F2"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M21.409 13.657a2.25 2.25 0 1 1 1.428 3.835l-1.8 4.114c.019.016.037.034.054.051a2.25 2.25 0 1 1-3.716.852l-1.687-1.35a2.25 2.25 0 0 1-1.35.333l-1.8 4.114.053.051A2.248 2.248 0 0 1 11 29.498a2.25 2.25 0 1 1 .164-4.494l1.8-4.113a2.248 2.248 0 0 1 1.537-3.893 2.249 2.249 0 0 1 2.124 2.99l1.687 1.35a2.25 2.25 0 0 1 1.352-.334l1.8-4.113a2.25 2.25 0 0 1-.054-3.234Zm1.591.841a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm-4.085 8.282a.75.75 0 1 0 .015-.02l-.015.02ZM14.5 18.498a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Zm-3.5 8a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z" fill="#8E9393"/>
  <path d="M32 14a7 7 0 1 0 0-14 7 7 0 0 0 0 14Z" fill="#E77464"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M29.825 3.727a.776.776 0 1 0-1.098 1.098L30.902 7l-2.175 2.175a.776.776 0 1 0 1.098 1.098L32 8.098l2.175 2.175a.776.776 0 0 0 1.097-1.098L33.098 7l2.175-2.175a.776.776 0 1 0-1.098-1.097L32 5.902l-2.175-2.175Z" fill="#fff"/>
</svg>`

const termsAndConditionsCTA = {
  type: 'CTA',
  ctaType: 'DEFAULT',
  method: 'POST',
  navigationStyle: 'PUSH',
  url: '/v1/user/static-site',
  isNavigationDeferred: false,
  requestPayload: {
    postBackParams: {
      staticSiteType: 'UNI_WEALTH_DISCLOSURE_DETAILS'
    }
  }
}
